module.exports = __webpack_public_path__ + "static/media/knele.97ff7306.m4a";